import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";
import ConditionRuleForm from "./ConditionRuleForm";

import useConditionRuleForm from "./useConditionRuleForm";

export default ConditionalRules;

function ConditionalRules(props) {
  const { node, closePanel, onSave, validationErrors } = props;

  const { formState, updateFormState, validate, errors } = useConditionRuleForm(
    node.data,
    validationErrors,
  );

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Branch Condition</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <ConditionRuleForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end items-center gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
